import FormElements from '@/components/DynamicForm/FormElements/ui-kits/default/FormElements';

import { CollectionInput } from '../../../types/DynamicFormTypes';

import { SingleAndMultiSelect } from './single-and-multi-select/SingleAndMultiSelect';

export default {
	...FormElements,
	'multi-select': (props: CollectionInput) => <SingleAndMultiSelect {...props} />,
	radio: (props: CollectionInput) => <SingleAndMultiSelect {...props} />,
};
